module.exports = __webpack_public_path__ + "static/img/1-2.b7fa77c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/1-2.png
// module id = iYjd
// module chunks = 0